import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { MessageCircle } from "lucide-react";

export default function SupportButton() {
  const location = useLocation();
  const [number, setNumber] = useState("");

  useEffect(() => {
    api.paymentInfo().then((d) => setNumber((d.support_whatsapp || "").replace(/\D/g, ""))).catch(() => {});
  }, []);

  // Hide on admin, public scan and policy pages
  const path = location.pathname;
  if (path.startsWith("/admin") || path.startsWith("/scan") || path.startsWith("/policy") || path.startsWith("/page")) return null;
  if (!number) return null;

  const href = `https://wa.me/${number}?text=${encodeURIComponent("Hi, I need help with DynaQR.")}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-support-btn"
      aria-label="WhatsApp support"
      className="fixed bottom-5 right-5 z-50 group flex items-center gap-2 rounded-full bg-accent text-accent-foreground shadow-lg glow-green pl-4 pr-5 py-3 active:scale-95 transition-transform duration-150"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2.2} />
      <span className="text-sm font-semibold hidden sm:inline">Need help?</span>
    </a>
  );
}
